import React from 'react';
import SkillIcon from './SkillIcon';

// Currently just an alias of SkillIcon
const AvailabilityCodeIcon = ({ code }) => <SkillIcon skill={code} />;

export default AvailabilityCodeIcon;
